const translations = {
    enter: 'Enter',
    pleaseCorrectTheFollowing: 'Please correct the following:'
};

export default translations;
